module.exports = __webpack_public_path__ + "static/media/google-wallet-button.56865ae3.png";